import React from 'react';
import { KycContext } from 'components/KycContext';

function useKyc() {
  return React.useContext(KycContext);
}

export default useKyc;
